import React from 'react'
import ZoneManagerEnquiryList from '../../features/zoneManager/ZoneManagerEnquiryList'

const ZoneManagerEnquiryListPage = () => {
  return <ZoneManagerEnquiryList/>
}

export default ZoneManagerEnquiryListPage